import { useState, useEffect } from 'react';

const FALLBACK = {
  advisor_application_url: 'https://form.typeform.com/to/IuLOXHct',
  platform_name: 'Viysr',
  allow_new_applications: true,
  allow_new_signups: true,
  enable_compare: true,
  enable_quiz: true,
};

let cachedSettings = null;
let pendingPromise = null;

async function loadSettings() {
  if (cachedSettings) return cachedSettings;
  if (pendingPromise) return pendingPromise;

  pendingPromise = fetch('/api/reference/platform-settings')
    .then(r => r.ok ? r.json() : {})
    .then(data => {
      cachedSettings = { ...FALLBACK, ...data };
      pendingPromise = null;
      return cachedSettings;
    })
    .catch(() => {
      pendingPromise = null;
      return FALLBACK;
    });

  return pendingPromise;
}

export function usePlatformSettings() {
  const [settings, setSettings] = useState(cachedSettings || FALLBACK);
  const [loading, setLoading] = useState(!cachedSettings);

  useEffect(() => {
    if (cachedSettings) { setSettings(cachedSettings); setLoading(false); return; }
    loadSettings().then(s => { setSettings(s); setLoading(false); });
  }, []);

  return { settings, loading };
}

export function clearPlatformSettingsCache() {
  cachedSettings = null;
}
